var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecrawl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6555 3.74149H5.06866C2.79262 3.74149 2.03394 5.85897 2.03394 7.5349C2.04388 8.16371 2.18389 8.78367 2.44514 9.35573C2.48007 9.43549 2.54137 9.5008 2.61876 9.5407C2.69615 9.58061 2.78491 9.59268 2.87014 9.57488C2.95537 9.55709 3.03189 9.51052 3.08684 9.44298C3.1418 9.37545 3.17185 9.29106 3.17196 9.20399V8.67747C3.17196 7.91879 3.5513 7.53945 5.06866 7.53945H12.6555V9.43615C12.6555 9.64479 12.77 9.68955 12.9104 9.53478L16.1939 5.92346C16.2618 5.84567 16.2991 5.74595 16.2991 5.64275C16.2991 5.53954 16.2618 5.43982 16.1939 5.36204L12.9104 1.75072C12.77 1.59898 12.6555 1.64071 12.6555 1.84934V3.74149Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34461 15.5091H14.9314C17.2075 15.5091 17.9661 13.3916 17.9661 11.7157C17.9558 11.0881 17.8158 10.4695 17.5549 9.89865C17.52 9.8189 17.4587 9.75358 17.3813 9.71368C17.3039 9.67378 17.2152 9.66171 17.1299 9.6795C17.0447 9.69729 16.9682 9.74387 16.9132 9.8114C16.8583 9.87893 16.8282 9.96332 16.8281 10.0504V10.5762C16.8281 11.3348 16.4488 11.7142 14.9314 11.7142H7.34461V9.81747C7.34461 9.60884 7.23005 9.56483 7.08969 9.71884L3.80612 13.3302C3.7383 13.408 3.70093 13.5077 3.70093 13.6109C3.70093 13.7141 3.7383 13.8138 3.80612 13.8916L7.08969 17.5029C7.23005 17.6546 7.34461 17.6129 7.34461 17.4043V15.5091Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecrawl);
export default __webpack_public_path__ + "static/media/recrawl.55ac976de5c652edfa7d76fc41c3a495.svg";
export { ForwardRef as ReactComponent };